var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.36719C10.8167 3.36719 3.3667 10.8172 3.3667 20.0005C3.3667 29.1839 10.8167 36.6339 20 36.6339C29.1834 36.6339 36.6334 29.1839 36.6334 20.0005C36.6334 10.8172 29.1834 3.36719 20 3.36719ZM19.1334 29.8005V22.9005H14.7C14.0834 22.9005 13.6667 22.2339 13.9667 21.6839L20.1 9.73385C20.4834 8.95052 21.6667 9.23385 21.6667 10.1172V17.1005H25.9C26.5167 17.1005 26.9167 17.7505 26.65 18.3005L20.7167 30.1672C20.3167 30.9672 19.1334 30.6839 19.1334 29.8005Z",
    fill: "#EF9C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/free.903f0b8848bb5a393e0a415365674245.svg";
export { ForwardRef as ReactComponent };